<template>
  
  <!-- full size card START -->
  <v-card color="grey lighten-4" hover height="100%" :to="{ name: 'New ' + type }" v-if="!minimized">
    <v-container fill-height>
      <v-layout align-center justify-center>
        <v-flex class="text-xs-center">
          <v-card-text class="title font-weight-thin">
            <v-icon>mdi-plus</v-icon><br>
            <span>Add {{ text }}</span>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
  <!-- full size card END -->

  <!-- minimized card START -->
  <v-card color="grey lighten-4" hover :to="{ name: 'New ' + type }" class="no-select" v-else>
    <v-card-text>
      <v-icon inline>mdi-plus</v-icon>
      <span >Add {{ text }}</span>
    </v-card-text>
  </v-card>
  <!-- minimized crad END -->

</template>


<script>
  export default {
    props: {
      type: String,
      minimized: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        text: String,
      }
    },
    mounted(){
      switch(this.type){
        case 'dataset':
          this.text='Data'
          break
        case 'api':
          this.text='Api'
          break
        case 'function':
          this.text='Function'
          break   
      }
    },
  }
</script>